module.exports = function prosImageSrc(imageData, customImgWidth, format) {
  const clearGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  if (imageData) {
    let { urlTemplate } = imageData;
    if (urlTemplate === '') {
      return clearGif;
    }
    urlTemplate = urlTemplate || 'https://slimages.macysassets.com/is/image/MCY/products';

    const { primaryImage } = imageData;
    let filePath = primaryImage ? primaryImage.filePath : imageData.filePath;
    const width = customImgWidth || (primaryImage && primaryImage.width ? primaryImage.width : 224);
    const quality = '90,0';
    let imgUrl = '';

    if (filePath) {
      if (!/\.(tif)$/i.test(filePath)) {
        filePath = `${filePath}.tif`;
      }

      if (urlTemplate.indexOf('[IMAGEFILEPATH]') > 0) {
        imgUrl = urlTemplate
          .replace(/\[IMAGEFILEPATH]/gi, filePath)
          .replace(/\[WIDTH]/gi, width)
          .replace(/\[QUALITY]/gi, quality);
        if (format === 'webp') {
          imgUrl += `${~imgUrl.indexOf('?') ? '&' : '?'}fmt=webp`; // eslint-disable-line no-bitwise
        }
      } else if (urlTemplate.indexOf('[WIDTH]') > 0) {
        imgUrl = urlTemplate
          .replace(/\[WIDTH]/gi, width)
          .replace(/\[QUALITY]/gi, quality);
        if (format === 'webp') {
          imgUrl += `${~imgUrl.indexOf('?') ? '&' : '?'}fmt=webp`; // eslint-disable-line no-bitwise
        }
      } else {
        imgUrl += `${urlTemplate}/${filePath}`;
        imgUrl += `?bgc=255,255,255&wid=${width}`;
        imgUrl += `&qlt=90,0&layer=comp&op_sharpen=0&resMode=bicub&op_usm=0.7,1.0,0.5,0&fmt=${format === 'webp' ? 'webp' : 'jpeg'}`;
      }
      return imgUrl;
    }
  }
  return clearGif;
};
